import TicketService from '_services/rest/modules/ticket';
import SettingsService from '_services/rest/modules/settings';
import AccessControlService from '_services/rest/modules/accessControl';
import { OPTION, COLOR_OPTION } from './components/SettingsModel';

export default {
  state: {
    roles: null,
    hired: null,
    company: null,
    messages: null,
    settings: null,
    userTypes: null,
    types: null,
    colors: null,
    contractor: null,
    itemsIncluded: null,
    paymentInfo: null,
  },
  mutations: {
    setColors(state, response) {
      state.colors = response;
    },
    setHireds(state, response) {
      state.hired = response;
    },
    setCompany(state, response) {
      state.company = response;
    },
    setMessages(state, response) {
      state.messages = response;
    },
    setSettings(state, response) {
      state.settings = response;
    },
    setRoles(state, response) {
      state.roles = response || [];
    },
    setTypes(state, response) {
      state.types = response || [];
    },
    setUserTypes(state, response) {
      state.userTypes = response || [];
    },
    addColor(state, option) {
      state.colors.push(option);
    },
    setContractors(state, response) {
      state.contractor = response;
    },
    addRole(state, option) {
      state.roles.push(option);
    },
    addType(state, option) {
      state.types.push(option);
    },
    setItemsIncluded(state, response) {
      state.itemsIncluded = response;
    },
    setPaymentInfo(state, response) {
      state.paymentInfo = response;
    },
  },
  actions: {
    getSettings({ commit }) {
      return SettingsService.getSettings()
        .then(response => {
          commit('setCompany', response.company);
          commit('setMessages', response.message);
          commit('setSettings', response.settings);
        });
    },
    getRoles({ commit }) {
      return AccessControlService.getRoles()
        .then(response => {
          commit('setRoles', response);
        });
    },
    getColor({ commit }) {
      return TicketService.getColors()
        .then(response => {
          if (response) {
            commit('setColors', response);
          }
          commit('addColor', { ...COLOR_OPTION });
        });
    },
    getType({ commit }) {
      return TicketService.getTypes()
        .then(response => {
          if (response) {
            commit('setTypes', response);
          }
          commit('addType', { ...OPTION });
        });
    },
    getUserTypes({ commit }) {
      return AccessControlService.getTypes()
        .then(response => {
          commit('setUserTypes', response);
        });
    },
    addColor({ commit }, params) {
      commit('addColor', params);
    },
    getHireds({ commit }) {
      return SettingsService.getQuotationContractualItems('hired')
        .then(response => {
          commit('setHireds', response);
        });
    },
    getContractors({ commit }) {
      return SettingsService.getQuotationContractualItems('contractor')
        .then(response => {
          commit('setContractors', response);
        });
    },
    addRole({ commit }, params) {
      commit('addRole', params);
    },
    addType({ commit }, params) {
      commit('addType', params);
    },
    getItemsIncluded({ commit }) {
      return SettingsService.getQuotationContractualItems('items_included')
        .then(response => {
          commit('setItemsIncluded', response);
        });
    },
    getPaymentInfo({ commit }) {
      return SettingsService.getQuotationContractualItems('payment_info')
        .then(response => {
          commit('setPaymentInfo', response);
        });
    },
  },
};
